import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Scadenza } from 'src/app/common/models/scadenza';
import { CreazionePraticaStoreService } from '../../../../services/creazione-pratica-store.service';
import { TipoScadenza } from 'src/app/common/models/tipologiche/tipo-scadenza';
import { FormGroup } from '@angular/forms';
import { CreazionePraticaTipologicheService } from '../../../../services/creazione-pratica-tipologiche.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({

  selector: 'app-step-adempimenti-list',
  templateUrl: './step-adempimenti-list.component.html',
  styleUrls: ['./step-adempimenti-list.component.css']
})
export class StepAdempimentiListComponent implements OnInit, OnDestroy {

  scadenze: Scadenza[] = [];
  scadenzeFiltrate: Scadenza[] = [];
  tipiScadenze: TipoScadenza[] = [];
  tipiScadenzeTabs: TipoScadenza[] = [{id: 'tutti', descrizione: 'Tutti', label: 'Tutti', rimosso: false}];
  formFiltro: FormGroup;
  currentTab: string = 'tutti';
  activeIndex: number;
  private componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(private creazionePraticaStoreService: CreazionePraticaStoreService, private tipologicheService: CreazionePraticaTipologicheService) {
    creazionePraticaStoreService.scadenze$.pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      this.scadenze = response;
      if(this.scadenze == null) this.scadenze = [];
    });
    this.tipologicheService.getTipiScadenza().pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      /*
      LOGICA PER MOSTRARE IL TIPO D'ADEMPIMENTO INCONTRO CGS, REINSTATARE AD IMPLEMENTAZIONE COMPLETA DEL TIPO
      if(this.creazionePraticaStore.getTipoFascicolo() != null && this.creazionePraticaStore.getTipoFascicolo().label != "SINISTRO SANITARIO")
        this.tipiScadenze = response.filter(el => el.id != 'INCONTRO');
      else
        this.tipiScadenze = response;*/
      // this.tipiScadenze = response.filter(el => el.id != 'INCONTRO');
      this.tipiScadenzeTabs = [...this.tipiScadenzeTabs, ...this.tipiScadenze];
    });
    this.scadenzeFiltrate = this.scadenze;
  }

  ngOnInit() {
  }

  ngOnDestroy(){
    this.componentDestroyed$.next();
  }

  setTab(tab: string){
    this.filterScadenza(tab);
  }

  filterScadenza(filter: string){
    this.activeIndex = undefined;
    this.currentTab = filter;
    if (filter === 'tutti') {
      this.scadenzeFiltrate = this.scadenze.filter(
        (scadenza: Scadenza) => scadenza.tipoScadenza.id !== null
      );
    } else {
      this.scadenzeFiltrate = this.scadenze.filter(
        (scadenza: Scadenza) => scadenza.tipoScadenza.id === filter
      );
    }
  }

  disassocia(scadenza: Scadenza){
    let filtered = this.scadenze.filter(el => el !== scadenza);
    console.log(filtered);
    this.filterScadenza(this.currentTab);
    this.creazionePraticaStoreService.setAdempimenti(filtered);
    this.creazionePraticaStoreService.save();
  }

  openDetail(scadenza: Scadenza, indice: number) {
    if (this.activeIndex === undefined || this.activeIndex !== indice) {
      this.activeIndex = indice;
    } else {
      this.activeIndex = undefined;
    }
  }

}
